import { findPropertyById, isPropertyComparing } from '../utils/properties';
import useListPagination from '../hooks/useListPagination';
import PropertyCard from '../components/property/PropertyCard';
import PaginationBar from '../components/shared/PaginationBar';
import PageRefinedHero from '../components/layout/PageRefinedHero';

const FavoritesPage = ({ properties, favorites, compareList, onToggleFav, onToggleCompare, onSelectProperty, country, isLoggedIn, setPage }) => {
  const seen = new Set();
  const favoriteProperties = [];
  for (const id of favorites) {
    const key = String(id);
    if (seen.has(key)) continue;
    const p = findPropertyById(properties, id);
    if (p) {
      seen.add(key);
      favoriteProperties.push(p);
    }
  }

  const favoritesKey = favorites.map((id) => String(id)).join(",");
  const {
    items: pageItems,
    page,
    total,
    totalPages,
    startIndex,
    endIndex,
    hasPrev,
    hasNext,
    goToPage
  } = useListPagination(favoriteProperties, favoritesKey);

  return (
    <div className="coown-page coown-page--hero" data-listings-anchor>
      <PageRefinedHero
        badge="Saved for you"
        title="Your curated"
        titleAccent="favorites"
        subtitle={
          isLoggedIn
            ? "Properties you saved with the heart icon — synced across your devices for quick access."
            : "Save properties with the heart icon while you browse. Sign in to sync favorites across devices."
        }
        benefits={[
          { icon: 'fas fa-heart', title: 'One-tap save', subtitle: 'Heart any listing from browse or home' },
          { icon: 'fas fa-balance-scale', title: 'Compare ready', subtitle: 'Shortlist deals side by side' },
          { icon: 'fas fa-bolt', title: 'Fast return', subtitle: 'Jump back to opportunities instantly' },
        ]}
      />

      <div className="coown-page-body">
        {favoriteProperties.length > 0 && (
          <div className="coown-page-toolbar">
            <div className="coown-page-toolbar__lead">
              <h2>{total} saved {total === 1 ? 'property' : 'properties'}</h2>
              <p>Tap a card to view details or remove with the heart icon.</p>
            </div>
            <div className="coown-page-toolbar__actions">
              <button type="button" className="btn btn-outline btn-sm" onClick={() => setPage("home")}>
                <i className="fas fa-search"></i> Browse more
              </button>
            </div>
          </div>
        )}

        {favoriteProperties.length === 0 ? (
          <div className="coown-page-empty">
            <i className="far fa-heart coown-page-empty__icon" aria-hidden="true"></i>
            <h3>No favorites yet</h3>
            <p>
              Tap the heart on any property on Home or Browse to save it here for quick access.
            </p>
            <button type="button" className="btn btn-primary" onClick={() => setPage("home")}>
              Explore properties
            </button>
          </div>
        ) : (
          <>
            <div className="properties-grid">
              {pageItems.map((p) => (
                <PropertyCard
                  key={p.id}
                  p={p}
                  isFavorite={true}
                  isComparing={isPropertyComparing(compareList, p.id)}
                  onToggleFav={onToggleFav}
                  onToggleCompare={onToggleCompare}
                  onClick={() => onSelectProperty(p)}
                  country={country}
                />
              ))}
            </div>
            <PaginationBar
              page={page}
              totalPages={totalPages}
              total={total}
              startIndex={startIndex}
              endIndex={endIndex}
              hasPrev={hasPrev}
              hasNext={hasNext}
              onPageChange={goToPage}
              itemLabel="favorites"
            />
          </>
        )}
      </div>
    </div>
  );
};

export default FavoritesPage;
